import React, { useContext, useEffect, useState } from "react";
import "./Faq_categories.css";
import { faCircleChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faqCategoryLuxury } from "../../../../utils/luxuryapis/Blog/Blog";
import { Context } from "../../../../utils/context";

function Faq_categories({ singleData, setSingleData }) {
  const [showSubCategory, setShowSubCategory] = useState(false);

  const handleToggle = () => {
    setShowSubCategory(!showSubCategory);
  };
  const [activeCategory, setActiveCategory] = useState(null);
  const { IMG_URL } = useContext(Context);
  const [data, setData] = useState([]);

  const getData = async () => {
    const res = await faqCategoryLuxury();
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (data?.length > 0) {
      setSingleData(data[0]);
    }
  }, [data]);

  return (
    <>
      <section className="Faq_categories">
        <div className="custom_container">
          <div className="content_box_holder">
            <div className="heading_strip_holder">
              <h1>Categories</h1>
              <hr />
            </div>

            <div className="Faq_categories_holder">
              <div className="row">
                {/* CARD 1 */}
                {data?.map((val) => (
                  <div className="col-md-4 col-sm-4 col-4">
                    <div className="Faq_categories_card_holder card_border_holder">
                      <div className="categories_img_holder">
                        <img
                          src={IMG_URL + val?.image}
                          alt="categories img"
                          className="categories_img"
                        />
                      </div>

                      <div className="text_holder">
                        <p>{val?.name}</p>
                      </div>

                      <div
                        className="arrow_icon_holder"
                        onClick={() => {
                          handleToggle();
                          setSingleData(val);
                          setActiveCategory(
                            activeCategory === val.id ? null : val.id,
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          className={`down_arrow ${
                            showSubCategory ? "rotate" : ""
                          }`}
                          icon={faCircleChevronDown}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                {/* <div className="col-md-4 col-sm-4 col-4">
                  <div className="Faq_categories_card_holder card_border_holder">
                    <div className="categories_img_holder">
                      <img
                        src="/assest/luxury_images/support/faq/faq_categories/user.png"
                        alt="categories img"
                        className="categories_img"
                      />
                    </div>

                    <div className="text_holder">
                      <p>Account</p>
                    </div>

                    <div className="arrow_icon_holder" onClick={handleToggle}>
                      <FontAwesomeIcon
                        className={`down_arrow ${
                          showSubCategory ? "rotate" : ""
                        }`}
                        icon={faCircleChevronDown}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-sm-4 col-4">
                  <div className="Faq_categories_card_holder">
                    <div className="categories_img_holder">
                      <img
                        src="/assest/luxury_images/support/faq/faq_categories/booking.png"
                        alt="categories img"
                        className="categories_img"
                      />
                    </div>

                    <div className="text_holder">
                      <p>Bookings</p>
                    </div>

                    <div className="arrow_icon_holder" onClick={handleToggle}>
                      <FontAwesomeIcon
                        className={`down_arrow ${
                          showSubCategory ? "rotate" : ""
                        }`}
                        icon={faCircleChevronDown}
                      />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            {/* SUB CATEGORY */}

            <div
              className={`sub_Category_holder ${
                activeCategory === singleData.id ? "show" : ""
              }`}
            >
              <div className="text_holder">
                {singleData?.faqs?.map((val) => (
                  <p>{val?.name}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq_categories;
